import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag, TrendingUp, MessageCircle, CreditCard, Truck } from 'lucide-react';
export function HeroVisual() {
  return <div className="relative w-full max-w-lg mx-auto lg:max-w-none lg:h-[500px] flex items-center justify-center mt-12 lg:mt-0" data-id="element-159">
      {/* Background glow */}
      <div className="absolute inset-0 bg-accent/20 blur-[100px] rounded-full" data-id="element-160"></div>

      {/* Main Store Catalog Card */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="relative z-10 bg-white rounded-2xl shadow-2xl border border-slate-100 w-full max-w-sm p-4 pt-[15px] pb-[15px] mt-[-30px] mb-[-30px]" data-id="element-161">
        <div className="flex items-center justify-between mb-4 border-b border-slate-100 pb-3" data-id="element-162">
          <div className="flex items-center gap-2" data-id="element-163">
            <ShoppingBag className="w-5 h-5 text-accent" data-id="element-164" />
            <span className="font-heading font-semibold text-slate-800 text-sm" data-id="element-165">
              Catálogo Activo
            </span>
          </div>
          <span className="text-xs font-medium bg-green-100 text-green-700 px-2 py-1 rounded-full" data-id="element-166">
            Online
          </span>
        </div>

        <div className="grid grid-cols-2 gap-3" data-id="element-167">
          {[3, 4].map(i => <div key={i} className="bg-slate-50 rounded-xl p-2 border border-slate-100" data-id="element-168">
              <div className="w-full h-24 bg-slate-200 rounded-lg mb-2" data-id="element-169"></div>
              <div className="h-3 w-3/4 bg-slate-300 rounded mb-1.5" data-id="element-170"></div>
              <div className="h-3 w-1/2 bg-accent/20 rounded" data-id="element-171"></div>
            </div>)}
        </div>
      </motion.div>

      {/* Floating Analytics Card */}
      <motion.div initial={{
      opacity: 0,
      x: 20
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.8,
      delay: 0.4
    }} className="absolute -right-4 lg:-right-12 top-10 z-20 bg-navy-900 rounded-xl shadow-xl border border-white/10 p-4 w-48 hidden sm:block" data-id="element-172">
        <div className="flex items-center gap-2 mb-3" data-id="element-173">
          <TrendingUp className="w-4 h-4 text-accent-light" data-id="element-174" />
          <span className="text-xs font-medium text-slate-300" data-id="element-175">
            Ventas del mes
          </span>
        </div>
        <div className="text-lg font-bold text-white mb-2" data-id="element-176">$4.2M CLP</div>
        {/* Simple SVG Sparkline */}
        <svg className="w-full h-12" viewBox="0 0 100 30" data-id="element-177">
          <path d="M0,30 L10,25 L20,28 L30,15 L40,20 L50,10 L60,15 L70,5 L80,10 L90,2 L100,8 L100,30 Z" fill="rgba(37, 99, 235, 0.2)" data-id="element-178" />
          <path d="M0,30 L10,25 L20,28 L30,15 L40,20 L50,10 L60,15 L70,5 L80,10 L90,2 L100,8" fill="none" stroke="#2563EB" strokeWidth="2" data-id="element-179" />
        </svg>
      </motion.div>

      {/* Floating WhatsApp Card */}
      <motion.div initial={{
      opacity: 0,
      x: -20
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.8,
      delay: 0.6
    }} className="absolute -left-4 lg:-left-8 bottom-24 z-20 bg-white rounded-xl shadow-lg border border-slate-100 p-3 flex items-center gap-3 w-56" data-id="element-180">
        <div className="bg-green-100 p-2 rounded-full" data-id="element-181">
          <MessageCircle className="w-5 h-5 text-green-600" data-id="element-182" />
        </div>
        <div data-id="element-183">
          <div className="text-xs font-bold text-slate-800" data-id="element-184">
            Nuevo pedido #1042
          </div>
          <div className="text-[10px] text-slate-500" data-id="element-185">
            Confirmado vía WhatsApp
          </div>
        </div>
      </motion.div>

      {/* Floating Payment/Shipping Card */}
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.8
    }} className="absolute right-4 lg:right-0 -bottom-6 z-20 bg-white rounded-xl shadow-lg border border-slate-100 p-3 flex flex-col gap-2" data-id="element-186">
        <div className="flex items-center gap-2 text-xs font-medium text-slate-700" data-id="element-187">
          <CreditCard className="w-4 h-4 text-slate-400" data-id="element-188" /> Pagos activos
        </div>
        <div className="flex items-center gap-2 text-xs font-medium text-slate-700" data-id="element-189">
          <Truck className="w-4 h-4 text-slate-400" data-id="element-190" /> Despacho config.
        </div>
      </motion.div>
    </div>;
}